import React from 'react';
import Loader from '../loader/Loader';
import { shortenWalletAddress } from '../../utils/commonFunction';

const BackendWalletSignInPanel = ({
    walletAddress,
    status,
    error,
    onRetry,
    title = 'Register your wallet',
    description = 'Sign a free message to create your CronPay account and save payment history on the server. This does not send a blockchain transaction.',
}) => {
    if (status === 'signing') {
        return (
            <div className="flex min-h-[50vh] flex-col items-center justify-center px-4 py-16">
                <div className="w-full max-w-md rounded-2xl border border-zinc-200 bg-white p-8 text-center shadow-sm dark:border-zinc-800 dark:bg-zinc-950/60">
                    <div className="mb-4 flex justify-center">
                        <Loader size="40px" stroke="#0d9488" />
                    </div>
                    <h2 className="text-lg font-semibold text-zinc-900 dark:text-white">
                        Confirm sign-in in your wallet
                    </h2>
                    <p className="mt-2 text-sm text-zinc-600 dark:text-zinc-400">
                        Approve the signature request to register{' '}
                        <span className="font-mono text-zinc-800 dark:text-zinc-200">
                            {shortenWalletAddress(walletAddress)}
                        </span>{' '}
                        with CronPay.
                    </p>
                </div>
            </div>
        );
    }

    if (status === 'error') {
        return (
            <div className="flex min-h-[50vh] flex-col items-center justify-center px-4 py-16">
                <div className="w-full max-w-md rounded-2xl border border-rose-200 bg-rose-50/60 p-8 text-center dark:border-rose-900/50 dark:bg-rose-950/20">
                    <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-rose-100 text-rose-700 dark:bg-rose-950/50 dark:text-rose-300">
                        <i className="fa-solid fa-triangle-exclamation" />
                    </div>
                    <h2 className="text-lg font-semibold text-zinc-900 dark:text-white">
                        Could not register wallet
                    </h2>
                    <p className="mt-2 text-sm text-rose-800 dark:text-rose-200/90">
                        {error}
                    </p>
                    <button
                        type="button"
                        onClick={() => onRetry?.({ force: true })}
                        className="mt-5 inline-flex items-center justify-center rounded-lg bg-teal-600 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-teal-700"
                    >
                        Try again
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="flex min-h-[50vh] flex-col items-center justify-center px-4 py-16">
            <div className="w-full max-w-md rounded-2xl border border-teal-200 bg-teal-50/50 p-8 text-center dark:border-teal-900/50 dark:bg-teal-950/20">
                <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-teal-100 text-teal-800 dark:bg-teal-950/50 dark:text-teal-300">
                    <i className="fa-solid fa-file-signature" />
                </div>
                <h2 className="text-lg font-semibold text-zinc-900 dark:text-white">
                    {title}
                </h2>
                <p className="mt-2 text-sm text-zinc-600 dark:text-zinc-400">
                    {description}
                </p>
                <button
                    type="button"
                    onClick={() => onRetry?.({ force: true })}
                    className="mt-5 inline-flex items-center justify-center rounded-lg bg-teal-600 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-teal-700"
                >
                    Sign in with wallet
                </button>
            </div>
        </div>
    );
};

export default BackendWalletSignInPanel;
